export type PatientRouteTab = {
  key: string;
  i18n: string;
  href: (id: string) => string;
};

export const PATIENT_ROUTE_TABS: PatientRouteTab[] = [
  { key: 'chart', i18n: 'patients.overview.tabs.chart', href: (id) => `/patients/${id}/chart` },
  { key: 'anamnesis', i18n: 'patients.overview.tabs.anamnesis', href: (id) => `/patients/${id}/anamnesis` },
  { key: 'health', i18n: 'patients.overview.tabs.health', href: (id) => `/patients/${id}/health` },
  { key: 'exams', i18n: 'patients.overview.tabs.exams', href: (id) => `/patients/${id}/exams` },
  { key: 'goals', i18n: 'patients.overview.tabs.goals', href: (id) => `/patients/${id}/goals` },
  { key: 'meal_plan', i18n: 'patients.overview.tabs.meal_plan', href: (id) => `/patients/${id}/meal-plan` },
  { key: 'supplements', i18n: 'patients.overview.tabs.supplements', href: (id) => `/patients/${id}/supplements` },
  { key: 'compounds', i18n: 'patients.overview.tabs.compounds', href: (id) => `/patients/${id}/compounds` },
  { key: 'anthropometry', i18n: 'patients.overview.tabs.anthropometry', href: (id) => `/patients/${id}/anthropometry` },
  { key: 'energy', i18n: 'patients.overview.tabs.energy', href: (id) => `/patients/${id}/energy` },
  { key: 'photos', i18n: 'patients.overview.tabs.photos', href: (id) => `/patients/${id}/photos` },
  { key: 'questionnaires', i18n: 'patients.overview.tabs.questionnaires', href: (id) => `/patients/${id}/questionnaires` },
  { key: 'guidance', i18n: 'patients.overview.tabs.guidance', href: (id) => `/patients/${id}/guidance` },
  { key: 'files', i18n: 'patients.overview.tabs.files', href: (id) => `/patients/${id}/files` },
  { key: 'receipts', i18n: 'patients.overview.tabs.receipts', href: (id) => `/patients/${id}/receipts` },
];
